import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 320 384",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 384\" id=\"icon-arrow-down\"><title>arrow-down</title><path d=\"M160,0a16,16,0,0,0-16,16V335.19L27.59,213A16,16,0,0,0,4.41,235l133,139.59a32,32,0,0,0,45.53-.28L315.59,235A16,16,0,0,0,292.42,213L176,335.7V16A16,16,0,0,0,160,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol